import { DataBean } from "../DataBean";

export class CashRequestBudgetvdos extends DataBean {



    public async getCashRequestBudget(year:any,idCashDeskAccount:any,budgetIDStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCashRequestBudget_Number_Number_String_Number_Number", [year,idCashDeskAccount,budgetIDStr,page,recordsPerPage]);
    }
    
}